import ArrowDownBottomLine from '@assets/icons/arrow-down-bottom-line.svg';
import ClockIcon from '@assets/icons/clock.svg';
import i18n from '@/utils/i18n';
import { createStyles } from '@/contexts/theme-context';
import { Typography } from '@usepepper/ui/atoms/typography';
import { View } from 'react-native';

interface OrderEntryFulfillmentInfoProps {
  cutoffTimeString?: string;
  orderMinimumDisplayString?: string;
}

export const OrderEntryFulfillmentAvailability: React.FC<
  OrderEntryFulfillmentInfoProps
> = ({ cutoffTimeString, orderMinimumDisplayString }) => {
  const [styles, theme] = useStyles();
  const hasConstraintContent = Boolean(
    cutoffTimeString || orderMinimumDisplayString,
  );
  const styledMinimumText = orderMinimumDisplayString ? (
    <View style={styles.fulfillmentConstraintContainer}>
      <Typography color={theme.sk.color.text.secondary} variant="paragraph-md">
        {i18n.t('sales_portal.fulfillment_settings.minimum')}{' '}
      </Typography>
      <Typography
        color={theme.sk.color.text.secondary}
        variant="paragraph-md-600"
      >
        {orderMinimumDisplayString}
      </Typography>
    </View>
  ) : null;

  const styledCutoffText = cutoffTimeString ? (
    <View style={styles.fulfillmentConstraintContainer}>
      <Typography color={theme.sk.color.text.secondary} variant="paragraph-md">
        {i18n.t('sales_portal.fulfillment_settings.cutoff')}{' '}
      </Typography>
      <Typography
        color={theme.sk.color.text.secondary}
        variant="paragraph-md-600"
      >
        {cutoffTimeString}
      </Typography>
    </View>
  ) : null;

  if (!hasConstraintContent) {
    return null;
  }
  return (
    <View style={styles.container}>
      {styledMinimumText ? (
        <View style={styles.constraintContainer}>
          <ArrowDownBottomLine fill={theme.sk.color.icon.secondary} />
          <View>{styledMinimumText}</View>
        </View>
      ) : null}
      {styledCutoffText ? (
        <View style={styles.constraintContainer}>
          <ClockIcon
            height={16}
            stroke={theme.sk.color.icon.secondary}
            width={16}
          />
          <View>{styledCutoffText}</View>
        </View>
      ) : null}
    </View>
  );
};

const useStyles = createStyles((theme) => ({
  constraintContainer: {
    alignItems: 'center',
    flexDirection: 'row',
    gap: theme.sk.spacing.spaceXsmall,
  },
  container: {
    flexDirection: 'row',
    gap: theme.sk.spacing.spaceSMedium,
  },
  fulfillmentConstraintContainer: {
    flexDirection: 'row',
  },
}));
